import React from 'react'
import { ResetAction } from './reset-action'
import { ArchiveSingleAction } from './archive-action'
import { RestoreSingleAction } from './restore-action'
import { ModifyApplicationTagsAction } from './tag-action'
import { DeleteSingleAction } from './delete-action'
import { PureQueryOptions } from 'apollo-client'
import { Role } from '@contrast-security-inc/base-types'
import { RowActionList } from '../../../legacy-design-system/grid'
import { useQueryClient } from 'react-query'
import { refreshAndInvalidateQueries } from './shared'
import { invalidateVrLicenseQueries } from '../../value-reporting/modules/licenses/api/queries/vr-licenses'

interface Application {
  readonly id: string
  readonly name: string
  readonly role: Role
  readonly archived: boolean
  readonly tags: string[]
}

export interface ApplicationActionProps {
  readonly organizationID: string
  readonly application: Application
  readonly isFreemium: boolean
  readonly restrictedEditRole?: boolean
  readonly refetchQueries: PureQueryOptions[]
  readonly refresh: () => Promise<any>
}

export function ApplicationRowActionList({
  application,
  refresh,
  restrictedEditRole,
  ...props
}: ApplicationActionProps) {
  const queryClient = useQueryClient()
  function licenseRelatedActionRefresh() {
    return refreshAndInvalidateQueries({
      queryClient,
      invalidate: invalidateVrLicenseQueries,
      refresh
    })
  }

  return (
    <RowActionList>
      <ModifyApplicationTagsAction
        applications={[application]}
        refresh={refresh}
        {...props}
      />
      <ArchiveSingleAction
        application={application}
        refresh={licenseRelatedActionRefresh}
        restrictedEditRole={restrictedEditRole}
        {...props}
      />
      <RestoreSingleAction
        application={application}
        refresh={licenseRelatedActionRefresh}
        {...props}
      />
      <ResetAction application={application} refresh={refresh} {...props} />
      <DeleteSingleAction
        application={application}
        refresh={licenseRelatedActionRefresh}
        {...props}
      />
    </RowActionList>
  )
}
